/**
 * SQLite hands timestamps out as "YYYY-MM-DD HH:MM:SS" in UTC, with no timezone marker — passed
 * straight to `Date`, that space (not `T`) makes most browsers read it as *local* time instead,
 * silently shifting every timestamp in the UI by the viewer's own UTC offset.
 */
export function parseUtc(sqliteTimestamp: string): Date {
  return new Date(`${sqliteTimestamp.replace(' ', 'T')}Z`);
}

/** Byte sizes for humans: "4.2 GB". Base 1000, the unit disk vendors and `df -H` use. */
export function formatBytes(bytes: number | null): string {
  if (bytes === null || !Number.isFinite(bytes)) return '–';
  if (bytes < 1000) return `${Math.round(bytes)} B`;
  const units = ['kB', 'MB', 'GB', 'TB', 'PB'];
  let value = bytes / 1000;
  let unit = 0;
  while (value >= 1000 && unit < units.length - 1) {
    value /= 1000;
    unit += 1;
  }
  // One decimal below 100, none above — "9.4 GB" reads better than "9 GB", "412 GB" than "412.0".
  return `${value < 100 ? value.toFixed(1) : Math.round(value)} ${units[unit]}`;
}
